import { all, fork, put, takeEvery } from 'redux-saga/effects';
import {
    SEARCH_STORE,
    SEARCH_STORE_SUCCESS,
    SEARCH_STORE_FAILED,
    VIEW_STORE,
    VIEW_STORE_SUCCESS,
    VIEW_STORE_FAILED,
    UPDATE_STORE,
    UPDATE_STORE_SUCCESS,
    UPDATE_STORE_FAILED,
    CREATE_STORE,
    CREATE_STORE_SUCCESS,
    CREATE_STORE_FAILED,
    DELETE_STORE,
    DELETE_STORE_SUCCESS,
    DELETE_STORE_FAILED,
    RESET_STATUS,
} from 'constants/ActionTypes';
import {
    searchStoreApi,
    viewStoreApi,
    updateStoreApi,
    createStoreApi,
    deleteStoreApi,
} from '../../appRedux/api/Store';
import { legacyStoreSearchPayload, legacyStoreViewPayload } from '../../appRedux/api/idpHelpers';
import { apiHandler, IDP_INQUIRY_SUCCESS, IDP_MUTATION_SUCCESS } from './handler';

function* fetchSearchStore({ payload }) {
    if (payload != null) {
        const { ok, data, message } = yield* apiHandler(searchStoreApi, payload, {
            successCodes: ['STR000', ...IDP_INQUIRY_SUCCESS],
        });

        if (ok) {
            yield put({ type: SEARCH_STORE_SUCCESS, payload: legacyStoreSearchPayload(data) });
        } else {
            yield put({ type: SEARCH_STORE_FAILED, payload: message });
        }
    }
}

function* fetchViewStore({ payload }) {
    if (payload != null) {
        const { ok, data, message } = yield* apiHandler(viewStoreApi, payload, {
            successCodes: ['STR903', ...IDP_INQUIRY_SUCCESS],
        });

        if (ok) {
            const legacy = legacyStoreViewPayload(data);
            yield put({ type: VIEW_STORE_SUCCESS, payload: legacy });
            localStorage.setItem('userData', JSON.stringify(legacy));
        } else {
            yield put({ type: VIEW_STORE_FAILED, payload: message });
        }
    }
}

function* postInsertStore({ payload }) {
    if (payload != null) {
        yield put({ type: RESET_STATUS });
        const { ok, data, message } = yield* apiHandler(createStoreApi, payload, {
            successCodes: ['STR900', ...IDP_MUTATION_SUCCESS],
        });

        if (ok) {
            yield put({
                type: CREATE_STORE_SUCCESS,
                payload: { ...data, data: data.body, ...(data.body != null ? { body: data.body } : {}) },
            });
        } else {
            yield put({ type: CREATE_STORE_FAILED, payload: message });
        }
    }
}

function* postEditStore({ payload }) {
    if (payload != null) {
        yield put({ type: RESET_STATUS });
        const { ok, data, message } = yield* apiHandler(updateStoreApi, payload, {
            successCodes: ['STR904', ...IDP_MUTATION_SUCCESS],
        });

        if (ok) {
            const body = data && data.body != null ? data.body : (data && data.product ? data.product : data);
            yield put({ type: UPDATE_STORE_SUCCESS, payload: body });
        } else {
            yield put({ type: UPDATE_STORE_FAILED, payload: message });
        }
    }
}

function* postDeleteStore({ payload }) {
    if (payload != null) {
        const { ok, data, message } = yield* apiHandler(deleteStoreApi, payload, {
            successCodes: ['STR906', ...IDP_MUTATION_SUCCESS],
        });

        if (ok) {
            const body = data && data.body != null ? data.body : (data && data.product ? data.product : data);
            yield put({ type: DELETE_STORE_SUCCESS, payload: body });
        } else {
            yield put({ type: DELETE_STORE_FAILED, payload: message });
        }
    }
}

export function* searchStore() {
    yield takeEvery(SEARCH_STORE, fetchSearchStore);
}

export function* viewStore() {
    yield takeEvery(VIEW_STORE, fetchViewStore);
}

export function* createStore() {
    yield takeEvery(CREATE_STORE, postInsertStore);
}

export function* updateStore() {
    yield takeEvery(UPDATE_STORE, postEditStore);
}

export function* deleteStore() {
    yield takeEvery(DELETE_STORE, postDeleteStore);
}

export default function* rootSaga() {
    yield all([
        fork(searchStore),
        fork(viewStore),
        fork(createStore),
        fork(updateStore),
        fork(deleteStore),
    ]);
}
